import { gsap } from "gsap";

const body = document.querySelector('body');

window.addEventListener('load', function () {

	const navToggles = document.querySelectorAll('.nav-toggle');
  const header = document.getElementById('#site-header');
  const navTL = gsap.timeline();

  // MOBILE NAV

  const handleNavToggleClick = () => {

    if( navTL.isActive() ){
      e.preventDefault(); // this will also stop <a> tag links
      e.stopImmediatePropagation(); // this will stop event bubbling
      return false;
    }

    body.classList.toggle('nav-active');

    if( body.classList.contains('nav-active') ){
      navToggles.forEach((navToggle) => {
        navToggle.setAttribute('aria-expanded', 'true');
      });
      navTL.staggerFromTo('#primary-menu li', 0.7, {x:100, opacity:0, delay:0.25}, {x:0, opacity:1}, 0.1);
    }else{
      navToggles.forEach((navToggle) => {
        navToggle.setAttribute('aria-expanded', 'false');
      });
      navTL.staggerFromTo('#primary-menu li', 0.35, {opacity:1}, {opacity:0}, 0.1);
    }

  }

  navToggles.forEach((navToggle) => {
    navToggle.addEventListener('click', handleNavToggleClick);
  });

}, false);

// HEADER SCROLL

const header = document.querySelector('.site-header');
const headerHeight = header.getBoundingClientRect().height;

window.addEventListener('scroll', function() {

  let scrollPosition = window.scrollY;
  if (scrollPosition >= window.innerHeight) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }

});